










import { Vue, Component, Prop, Model } from "vue-property-decorator";
import {
	busy,
	VIPCertificatePipelineType,
	VIPCertificatePipelineTypeToArray,
	VIPCertificatePipelineTypeFromArray,
} from "@/loader";

@Component
export default class CertificatePipelineTypeInput extends Vue {
	@Prop({ type: String, default: "outline-info" })
	public readonly variant!: string;

	@Prop({ type: Boolean, default: false })
	public readonly canEdit!: boolean;

	@Prop({ type: Boolean, default: false })
	public readonly shortText!: boolean;

	@Model("input", { type: Number, required: true })
	public readonly value: VIPCertificatePipelineType;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get items(): any[] {
		return [
			{
				value: VIPCertificatePipelineType.gravity,
				text: this.shortText ? "EL" : "Ecoulement surface Libre",
			},
			{
				value: VIPCertificatePipelineType.pressure,
				text: this.shortText ? "SP" : "Sous Pression",
			},
			// {
			// 	value: VIPCertificatePipelineType.void,
			// 	text: this.shortText ? "V" : "sous vide",
			// },
		];
	}

	public get active(): VIPCertificatePipelineType[] {
		return VIPCertificatePipelineTypeToArray(this.value);
	}
	public set active(value: VIPCertificatePipelineType[]) {
		this.$emit("input", VIPCertificatePipelineTypeFromArray(value));
	}
}
